var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.9466 22.9999C12.4707 22.9999 12.8851 22.8061 13.1776 22.4288L24.6953 7.25376C24.9147 6.95801 25 6.73365 25 6.49909C25 5.93818 24.5612 5.57104 23.8909 5.57104C23.4033 5.57104 23.1352 5.70362 22.8427 6.09116L11.8979 20.6849L6.21822 14.464C5.91352 14.107 5.60883 13.9643 5.17005 13.9643C4.47533 13.9643 4 14.362 4 14.9228C4 15.1575 4.12188 15.4226 4.35345 15.6673L10.6791 22.4084C11.0447 22.8061 11.4225 22.9999 11.9466 22.9999Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheck);
export default __webpack_public_path__ + "static/media/check.9db155380d486d124097682b48b0664c.svg";
export { ForwardRef as ReactComponent };